export default __webpack_public_path__ + "static/media/background_molecule_2.3f828e12.jpg";